import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { DatePicker, Form } from 'antd';
import { getPaciente } from '../../../state/actions/creators/pacientes.actioncreator';
import { getPrescriptores } from '../../../state/actions/creators/fichaOptometrica.actioncreator';
import {
  getDatosFichaContactologica,
  getDatosUltimaOptometria,
} from '../../../state/actions/creators/fichaContactologica.actioncreator';
import Page from '../../shared/components/layout/Page.layout';
import { Box, Flex, Text } from '../../shared/components';
import LoadingWorkspaceSkeleton from '../../encargos/components/dataDisplay/LoadingWorkspaceSkeleton.datadisplay';
import { FichaContactologicaFormulario } from './fichaContactologica.form';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';
import ReadOnly from '../../shared/components/dataEntry/ReadOnly';
import EditableTable from '../../shared/containers/EditableTable';
import { columns_1, columns_2 } from './contactologiaTables';

export function FichaContactologicaFormGraduacionAsociada({
  watch,
  create,
  form,
  onSetValue,
  datosGraduacion,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const { pacienteId, codigo } = params;
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  const prescriptores = useSelector(state => state.fichaOptometricaWorkspace.prescriptores);
  const paciente = useSelector(state => state.pacientesWorkspace.pacienteSelected);
  const tiendas = useSelector(state => state.core.tiendas);
  const sagas = useSelector(state => state.sagas);
  const datosGraduacionOriginal = useSelector(state => state.fichaContactologicaWorkspace.fichaContactologica);
  const tiendaCreate = create ? tiendas.find(e => e.id === tiendaId) : null;
  const tiendaCreateName = create && tiendaCreate ? tiendaCreate.nombre : null;
  const { getFieldDecorator } = form;
  useEffect(() => {
  }, []);
  const optometrica_asociada = datosGraduacion && datosGraduacion.graduacion_optometrica_asociada;
  const dataSource_1 = [
    {
      key: '1',
      ojo: 'Dcho.',
      esfLejos: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_derecho?.esfera_lejos,
      esfCerca: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_derecho?.esfera_cerca,
      eje: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_derecho?.eje,
      avcc: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_derecho?.avcc,
      cilindro: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_derecho?.cilindro,
      adicion: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_derecho?.adicion,


    },
    {
      key: '2',
      ojo: 'Izdo.',
      esfLejos: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_izquierdo?.esfera_lejos,
      esfCerca: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_izquierdo?.esfera_cerca,
      eje: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_izquierdo?.eje,
      avcc: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_izquierdo?.avcc,
      cilindro: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_izquierdo?.cilindro,
      adicion: optometrica_asociada && optometrica_asociada?.prescripcion?.ojo_izquierdo?.adicion,

    },
  ];
  const dataSource_2 = [
    {
      key: '1',
      ojo: 'Dcho.',
      queratometria: optometrica_asociada && optometrica_asociada.queratometria && optometrica_asociada.queratometria?.ojo_derecho,

    },
    {
      key: '2',
      ojo: 'Izdo.',
      queratometria: optometrica_asociada && optometrica_asociada.queratometria && optometrica_asociada.queratometria?.ojo_izquierdo,

    },
  ];
  const handleTableDataChange = ({ rowKey, newRow }) => {
    let copiaQueratometria = null;
    if (rowKey === '1') {
      const ojo_derecho = newRow.queratometria;
      copiaQueratometria = datosGraduacion.graduacion_optometrica_asociada.queratometria ? {
        ...datosGraduacion.graduacion_optometrica_asociada.queratometria,
        ojo_derecho,
      } : { ojo_derecho };
    } else {
      const ojo_izquierdo = newRow.queratometria
      copiaQueratometria = datosGraduacion.graduacion_optometrica_asociada.queratometria ? {
        ...datosGraduacion.graduacion_optometrica_asociada.queratometria,
        ojo_izquierdo,
      } : { ojo_izquierdo };
    }
    onSetValue({ graduacion_optometrica_asociada: { ...optometrica_asociada, queratometria: copiaQueratometria } }, {});
  };
  return (
    <>
      <Text width="425px"fontFamily="Open Sans" color="#3E3E3C" fontWeight="600" fontSize="16px" translationId="ficha_contactologica.graduacion_optometrica_asociada">Graduación optométrica asociada</Text>
      <EditableTable
        mt="16px"
        readOnly
        size="middle"
        basic
        rowSelection={false}
        className="table-graduacion"
          // onRowChange={data => this.onHandleTableDataChange(data, datosGraduacion, 'table-graduacion')}
        dataSource={dataSource_1}
        columns={columns_1}
        pagination={false}
      />
      <Flex width="100%">
        <EditableTable
          mt="16px"
          readOnly
          size="middle"
          basic
          rowSelection={false}
          className="table-queratometria"
          //onRowChange={data => handleTableDataChange(data)}
          dataSource={dataSource_2}
          columns={columns_2}
          pagination={false}
        />
      </Flex>
    </>
  );
}
